import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import { Badge, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import RateAppDialog from '../rateAppDialog/rateAppDialog';
import { selectUserRating } from '../user/userSlice';

export default function NotificationsMenu(props) {

    const userRating = useSelector(selectUserRating);

    const [open, setOpen] = React.useState(false);
    const [notificationsRequiringAction, setNotificationsRequiringAction] = React.useState(0);

    React.useEffect(() => {
        if(userRating.submitted === false) {
            setNotificationsRequiringAction(1);
        } else {
            setNotificationsRequiringAction(0);
        }
    }, [userRating]);

    const handleOpenDialog = () => {
      setOpen(true);
    };
  
    const handleCloseDialog = (event) => {
      setOpen(false);
    };

    return (
        <React.Fragment>
        <Tooltip title="Powiadomienia">
            
            <IconButton
                id='header-notifications-button'
                onClick={handleOpenDialog} 
            >
                <Badge color='info' overlap="circular" badgeContent={notificationsRequiringAction} anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
                    <ManageHistoryOutlinedIcon sx={{ width: 28, height: 28, color:'white' }} />
                </Badge>    
            </IconButton>
        </Tooltip>
        <RateAppDialog
                open={open}
                onClose={handleCloseDialog}
                fullWidth={true} 
                
            />
        </React.Fragment>
    );    
}